var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKeyContractClauseSidebar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7096_14035",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7096_14035)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.4 4.4V8.6175V8.6V15.6V4.4ZM4.4 17C4.015 17 3.68542 16.8629 3.41125 16.5887C3.13708 16.3146 3 15.985 3 15.6V4.4C3 4.015 3.13708 3.68542 3.41125 3.41125C3.68542 3.13708 4.015 3 4.4 3H10L14.2 7.2V8.95C13.9783 8.85667 13.7508 8.78375 13.5175 8.73125C13.2842 8.67875 13.045 8.64083 12.8 8.6175V7.9H9.3V4.4H4.4V15.6H8.6175C8.80417 15.88 9.01417 16.1396 9.2475 16.3788C9.48083 16.6179 9.7375 16.825 10.0175 17H4.4ZM12.45 14.9C12.94 14.9 13.3542 14.7308 13.6925 14.3925C14.0308 14.0542 14.2 13.64 14.2 13.15C14.2 12.66 14.0308 12.2458 13.6925 11.9075C13.3542 11.5692 12.94 11.4 12.45 11.4C11.96 11.4 11.5458 11.5692 11.2075 11.9075C10.8692 12.2458 10.7 12.66 10.7 13.15C10.7 13.64 10.8692 14.0542 11.2075 14.3925C11.5458 14.7308 11.96 14.9 12.45 14.9ZM16.02 17.7L14.13 15.81C13.885 15.9733 13.6196 16.0958 13.3337 16.1775C13.0479 16.2592 12.7533 16.3 12.45 16.3C11.575 16.3 10.8312 15.9937 10.2188 15.3812C9.60625 14.7688 9.3 14.025 9.3 13.15C9.3 12.275 9.60625 11.5312 10.2188 10.9187C10.8312 10.3063 11.575 10 12.45 10C13.325 10 14.0687 10.3063 14.6812 10.9187C15.2937 11.5312 15.6 12.275 15.6 13.15C15.6 13.4533 15.5592 13.7479 15.4775 14.0337C15.3958 14.3196 15.2733 14.585 15.11 14.83L17 16.72L16.02 17.7Z",
    fill: "#40444D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyContractClauseSidebar);
export default __webpack_public_path__ + "static/media/key_contract_clause_sidebar.ce493a1d232cd7d2e09a133c1bb25b34.svg";
export { ForwardRef as ReactComponent };